import React, { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Container, Row, Col } from "react-bootstrap";
import Image3 from "../assets/images/company/image-3.jpg";

function RefundPolicy({ setPageTitle }) {

    useEffect(() => {
        setPageTitle("Refund Policy - Bait Al Anaqah");
    }, [setPageTitle]);

    return (
        <>
            <Helmet>
                <meta name="keywords" content="Bait Al Anaqah, Bespoke, Uniforms, Alteration, Custom, Dubai" />
                <meta name="title" property="og:title" content={setPageTitle}></meta>
                <meta property="og:type" content="website" />
                <meta name="description" property="og:description" content="Experience the elegance of Bait Al Anaqah, where every creation tells a story and reflects your unique identity while honoring your values." />
                <meta name="image" property="og:image" content={Image3} />
            </Helmet>
            <Navbar />
            <Container className="py-5">
                <Row>
                    <Col lg={8} className="mx-auto">
                        <h1 className="mb-5">Refund Policy</h1>
                        <p>
                        At Bait Al Anaqah, we understand that you may occasionally need to request a refund, exchange, or cancellation for items purchased. We are committed to making this process as straightforward as possible while ensuring client satisfaction.
                        </p>
                        <h5 className="fw-bold">
                        Refund
                        </h5>
                        <p>
                        Our refund policy allows for returns or exchanges within 14 days of your order, provided the following conditions are met:
                        <ul>
                            <li>
                            The item must be unworn, unused, and in the same condition as when you received it, with original tags/labels intact.
                            </li>
                            <li>
                            The packaging must be in its original state.
                            </li>
                            <li>
                            A receipt or proof of purchase must accompany the item.
                            </li>
                            <li>
                            Items purchased at a discount of 10% or more are not eligible for return.
                            </li>
                        </ul>
                        </p>
                        <p>
                        To initiate a return, please complete our return form. Processing your return may take up to 14 days from the date of your request.
                        </p>
                        <p>
                        Bait Al Anaqah
                        </p>
                        <p>
                        Customer Care Team
                        </p>
                        <p>
                        Dubai, UAE
                        </p>
                        <p>
                        P.O. Box 33302
                        </p>
                        <p>
                        Please note that clients are responsible for covering the shipping expenses for returns. The cost of return shipping will be deducted from your refund amount and is non-refundable.
                        </p>
                        <p>
                        Once your returned item reaches us and passes our quality checks, we will send you an email to confirm receipt and inform you of the status of your refund request. If your return meets our criteria, we will initiate the refund to your original payment method (e.g., credit card).
                        </p>
                        <p>
                        Please be aware that the timing for the refund to appear in your account depends on your card issuer’s policies, and Bait Al Anaqah does not claim responsibility for delays caused by the card issuer.
                        </p>
                        <h5 className="fw-bold">
                        Did not receive your refund?
                        </h5>
                        <p>
                        If your refund has not reached you within the expected timeframe, please verify with your bank first. Processing times may vary. If you still do not receive your refund, contact us at info@baitalanaqah.com.
                        </p>
                        <p>
                        Please note: Items purchased on sale are not eligible for refunds.
                        </p>
                        <h5 className="fw-bold">
                        Exchanges
                        </h5>
                        <p>
                        Replacements are available only for defective or damaged items. If you need to exchange your purchase for these reasons, contact us at info@baitalanaqah.com with details about the issue.
                        </p>
                        <p>
                        Eligible items for exchange can be shipped to the address above.
                        </p>
                        <h5 className="fw-bold">
                        Gift Returns/Exchanges
                        </h5>
                        <p>
                        If the item was purchased as a gift and sent directly to you, any refunds will be issued in the form of a gift credit once we receive the returned item. You will receive a gift certificate by mail.
                        </p>
                        <p>
                        If the item was not marked as a gift during purchase or the buyer had it shipped to themselves before gifting it to you, any refunds will be credited to the original payment method of the buyer. The buyer will be informed about the refund, return, or exchange request.
                        </p>
                        <h5 className="fw-bold">
                        Questions? Contact Us
                        </h5>
                        <p>
                        For any additional queries, email our Client Care Team at info@baitalanaqah.com. Our team is available Saturday to Thursday between 09:00 and 16:00 UAE Standard Time.
                        </p>
                        
                    </Col>
                </Row>
            </Container>
            <Footer />
        </>
    );
}

export default RefundPolicy;
